module.exports = __webpack_public_path__ + "static/rocketmb-221d8f726033f6ce3e95b7a555e28686.png";